(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1223,839],{

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 45578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    baseUniq = __webpack_require__(45652);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 52675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/dummy.2ef4c1a8.png","height":480,"width":640,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAACVBMVEXNzc29vb3FxcXtfrqkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAFklEQVR4nGNgwARMjExMjFAGI5iBDgAB2gAQAiYAVwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 20839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ collection_title; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/home/PlacesSearch/index.jsx + 2 modules
var PlacesSearch = __webpack_require__(69174);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js + 3 modules
var react_responsive_modal_esm = __webpack_require__(31190);
;// CONCATENATED MODULE: ./src/components/productcollection/common/model.jsx


function Model(param) {
    var imageUrl = param.imageUrl, label = param.label, fontSize = param.fontSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "outlined model",
        style: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: imageUrl,
                alt: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    fontWeight: 600
                },
                children: label
            })
        ]
    });
}
/* harmony default export */ var model = (Model);

;// CONCATENATED MODULE: ./src/components/productcollection/common/collection-title.jsx





function CollectionTitle(param) {
    var label = param.label, locationRequired = param.locationRequired, geolocation = param.geolocation, imageUrl = param.imageUrl, isUpdating = param.isUpdating, first_name = param.first_name, isAvailable = param.isAvailable;
    var ref = (0,react.useState)(false), showAddressModal = ref[0], setShowAddressModal = ref[1];
    var formattedAddress = (geolocation === null || geolocation === void 0 ? void 0 : geolocation.formattedAddress) || (geolocation === null || geolocation === void 0 ? void 0 : geolocation.formatted_address);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesSearch/* default */.Z, {
                modalOnly: true,
                isModalOpen: showAddressModal
            }),
            !isUpdating ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "collection-title",
                        children: [
                            isAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "info success",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fad fa-check-circle",
                                        "aria-hidden": "true"
                                    }),
                                    first_name ? "Hi, ".concat(first_name) : "Products Available",
                                    " "
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "info error",
                                children: [
                                    "Products",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "info helper",
                                children: first_name ? " items for " : "for your "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(model, {
                                imageUrl: imageUrl ? imageUrl : "",
                                label: label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " "
                            }),
                            !locationRequired && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "outlined location",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-weight-normal",
                                        children: "Near "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mr-2",
                                        children: formattedAddress === null || formattedAddress === void 0 ? void 0 : formattedAddress.replace(/,[^,]+$/, "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn",
                                        onClick: function() {
                                            return setShowAddressModal(true);
                                        },
                                        children: "(Change)"
                                    })
                                ]
                            })
                        ]
                    }),
                    locationRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                width: "300px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "Update Your Location - Required"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "collection-title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "info success",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-cog fa-spin",
                            "aria-hidden": "true"
                        }),
                        " Loading Locations. Please Wait..."
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var collection_title = (CollectionTitle);


/***/ }),

/***/ 35074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ productcollection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/category/Bio/index.jsx
var Bio = __webpack_require__(18016);
// EXTERNAL MODULE: ./src/components/productcollection/common/collection-title.jsx + 1 modules
var collection_title = __webpack_require__(20839);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./src/functions/groupArrayByValue.js
var groupArrayByValue = function(list, keyGetter) {
    var map = new Map();
    list.forEach(function(item) {
        var key = keyGetter(item);
        var collection = map.get(key);
        if (!collection) {
            map.set(key, [
                item
            ]);
        } else {
            collection.push(item);
        }
    });
    return map;
};
/* harmony default export */ var functions_groupArrayByValue = (groupArrayByValue);

// EXTERNAL MODULE: ./src/redux/actions/index.js + 7 modules
var actions = __webpack_require__(89703);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js
var parsePhoneNumber = __webpack_require__(25631);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/findPhoneNumbersInText.js + 11 modules
var findPhoneNumbersInText = __webpack_require__(96981);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
;// CONCATENATED MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

var ThresholdUnits = {
    Pixel: 'Pixel',
    Percent: 'Percent',
};
var defaultThreshold = {
    unit: ThresholdUnits.Percent,
    value: 0.8,
};
function parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === 'number') {
        return {
            unit: ThresholdUnits.Percent,
            value: scrollThreshold * 100,
        };
    }
    if (typeof scrollThreshold === 'string') {
        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) {
            return {
                unit: ThresholdUnits.Pixel,
                value: parseFloat(scrollThreshold),
            };
        }
        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) {
            return {
                unit: ThresholdUnits.Percent,
                value: parseFloat(scrollThreshold),
            };
        }
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return defaultThreshold;
    }
    console.warn('scrollThreshold should be string or number');
    return defaultThreshold;
}

var InfiniteScroll = /** @class */ (function (_super) {
    __extends(InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollTop = 0;
        _this.actionTriggered = false;
        // variables to keep track of pull down behaviour
        _this.startY = 0;
        _this.currentY = 0;
        _this.dragging = false;
        // will be populated in componentDidMount
        // based on the height of the pull down element
        _this.maxPullDownDistance = 0;
        _this.getScrollableTarget = function () {
            if (_this.props.scrollableTarget instanceof HTMLElement)
                return _this.props.scrollableTarget;
            if (typeof _this.props.scrollableTarget === 'string') {
                return document.getElementById(_this.props.scrollableTarget);
            }
            if (_this.props.scrollableTarget === null) {
                console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
            }
            return null;
        };
        _this.onStart = function (evt) {
            if (_this.lastScrollTop)
                return;
            _this.dragging = true;
            if (evt instanceof MouseEvent) {
                _this.startY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.startY = evt.touches[0].pageY;
            }
            _this.currentY = _this.startY;
            if (_this._infScroll) {
                _this._infScroll.style.willChange = 'transform';
                _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
            }
        };
        _this.onMove = function (evt) {
            if (!_this.dragging)
                return;
            if (evt instanceof MouseEvent) {
                _this.currentY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.currentY = evt.touches[0].pageY;
            }
            // user is scrolling down to up
            if (_this.currentY < _this.startY)
                return;
            if (_this.currentY - _this.startY >=
                Number(_this.props.pullDownToRefreshThreshold)) {
                _this.setState({
                    pullToRefreshThresholdBreached: true,
                });
            }
            // so you can drag upto 1.5 times of the maxPullDownDistance
            if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5)
                return;
            if (_this._infScroll) {
                _this._infScroll.style.overflow = 'visible';
                _this._infScroll.style.transform = "translate3d(0px, " + (_this.currentY -
                    _this.startY) + "px, 0px)";
            }
        };
        _this.onEnd = function () {
            _this.startY = 0;
            _this.currentY = 0;
            _this.dragging = false;
            if (_this.state.pullToRefreshThresholdBreached) {
                _this.props.refreshFunction && _this.props.refreshFunction();
                _this.setState({
                    pullToRefreshThresholdBreached: false,
                });
            }
            requestAnimationFrame(function () {
                // this._infScroll
                if (_this._infScroll) {
                    _this._infScroll.style.overflow = 'auto';
                    _this._infScroll.style.transform = 'none';
                    _this._infScroll.style.willChange = 'unset';
                }
            });
        };
        _this.onScrollListener = function (event) {
            if (typeof _this.props.onScroll === 'function') {
                // Execute this callback in next tick so that it does not affect the
                // functionality of the library.
                setTimeout(function () { return _this.props.onScroll && _this.props.onScroll(event); }, 0);
            }
            var target = _this.props.height || _this._scrollableNode
                ? event.target
                : document.documentElement.scrollTop
                    ? document.documentElement
                    : document.body;
            // return immediately if the action has already been triggered,
            // prevents multiple triggers.
            if (_this.actionTriggered)
                return;
            var atBottom = _this.props.inverse
                ? _this.isElementAtTop(target, _this.props.scrollThreshold)
                : _this.isElementAtBottom(target, _this.props.scrollThreshold);
            // call the `next` function in the props to trigger the next data fetch
            if (atBottom && _this.props.hasMore) {
                _this.actionTriggered = true;
                _this.setState({ showLoader: true });
                _this.props.next && _this.props.next();
            }
            _this.lastScrollTop = target.scrollTop;
        };
        _this.state = {
            showLoader: false,
            pullToRefreshThresholdBreached: false,
            prevDataLength: props.dataLength,
        };
        _this.throttledOnScrollListener = throttle(150, _this.onScrollListener).bind(_this);
        _this.onStart = _this.onStart.bind(_this);
        _this.onMove = _this.onMove.bind(_this);
        _this.onEnd = _this.onEnd.bind(_this);
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function () {
        if (typeof this.props.dataLength === 'undefined') {
            throw new Error("mandatory prop \"dataLength\" is missing. The prop is needed" +
                " when loading more content. Check README.md for usage");
        }
        this._scrollableNode = this.getScrollableTarget();
        this.el = this.props.height
            ? this._infScroll
            : this._scrollableNode || window;
        if (this.el) {
            this.el.addEventListener('scroll', this
                .throttledOnScrollListener);
        }
        if (typeof this.props.initialScrollY === 'number' &&
            this.el &&
            this.el instanceof HTMLElement &&
            this.el.scrollHeight > this.props.initialScrollY) {
            this.el.scrollTo(0, this.props.initialScrollY);
        }
        if (this.props.pullDownToRefresh && this.el) {
            this.el.addEventListener('touchstart', this.onStart);
            this.el.addEventListener('touchmove', this.onMove);
            this.el.addEventListener('touchend', this.onEnd);
            this.el.addEventListener('mousedown', this.onStart);
            this.el.addEventListener('mousemove', this.onMove);
            this.el.addEventListener('mouseup', this.onEnd);
            // get BCR of pullDown element to position it above
            this.maxPullDownDistance =
                (this._pullDown &&
                    this._pullDown.firstChild &&
                    this._pullDown.firstChild.getBoundingClientRect()
                        .height) ||
                    0;
            this.forceUpdate();
            if (typeof this.props.refreshFunction !== 'function') {
                throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
            }
        }
    };
    InfiniteScroll.prototype.componentWillUnmount = function () {
        if (this.el) {
            this.el.removeEventListener('scroll', this
                .throttledOnScrollListener);
            if (this.props.pullDownToRefresh) {
                this.el.removeEventListener('touchstart', this.onStart);
                this.el.removeEventListener('touchmove', this.onMove);
                this.el.removeEventListener('touchend', this.onEnd);
                this.el.removeEventListener('mousedown', this.onStart);
                this.el.removeEventListener('mousemove', this.onMove);
                this.el.removeEventListener('mouseup', this.onEnd);
            }
        }
    };
    InfiniteScroll.prototype.componentDidUpdate = function (prevProps) {
        // do nothing when dataLength is unchanged
        if (this.props.dataLength === prevProps.dataLength)
            return;
        this.actionTriggered = false;
        // update state when new data was sent in
        this.setState({
            showLoader: false,
        });
    };
    InfiniteScroll.getDerivedStateFromProps = function (nextProps, prevState) {
        var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
        // reset when data changes
        if (dataLengthChanged) {
            return __assign(__assign({}, prevState), { prevDataLength: nextProps.dataLength });
        }
        return null;
    };
    InfiniteScroll.prototype.isElementAtTop = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop <=
                threshold.value + clientHeight - target.scrollHeight + 1);
        }
        return (target.scrollTop <=
            threshold.value / 100 + clientHeight - target.scrollHeight + 1);
    };
    InfiniteScroll.prototype.isElementAtBottom = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop + clientHeight >= target.scrollHeight - threshold.value);
        }
        return (target.scrollTop + clientHeight >=
            (threshold.value / 100) * target.scrollHeight);
    };
    InfiniteScroll.prototype.render = function () {
        var _this = this;
        var style = __assign({ height: this.props.height || 'auto', overflow: 'auto', WebkitOverflowScrolling: 'touch' }, this.props.style);
        var hasChildren = this.props.hasChildren ||
            !!(this.props.children &&
                this.props.children instanceof Array &&
                this.props.children.length);
        // because heighted infiniteScroll visualy breaks
        // on drag down as overflow becomes visible
        var outerDivStyle = this.props.pullDownToRefresh && this.props.height
            ? { overflow: 'auto' }
            : {};
        return (react.createElement("div", { style: outerDivStyle, className: "infinite-scroll-component__outerdiv" },
            react.createElement("div", { className: "infinite-scroll-component " + (this.props.className || ''), ref: function (infScroll) { return (_this._infScroll = infScroll); }, style: style },
                this.props.pullDownToRefresh && (react.createElement("div", { style: { position: 'relative' }, ref: function (pullDown) { return (_this._pullDown = pullDown); } },
                    react.createElement("div", { style: {
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: -1 * this.maxPullDownDistance,
                        } }, this.state.pullToRefreshThresholdBreached
                        ? this.props.releaseToRefreshContent
                        : this.props.pullDownToRefreshContent))),
                this.props.children,
                !this.state.showLoader &&
                    !hasChildren &&
                    this.props.hasMore &&
                    this.props.loader,
                this.state.showLoader && this.props.hasMore && this.props.loader,
                !this.props.hasMore && this.props.endMessage)));
    };
    return InfiniteScroll;
}(react.Component));

/* harmony default export */ var index_es = (InfiniteScroll);
//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js + 3 modules
var react_responsive_modal_esm = __webpack_require__(31190);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 7 modules
var react_select_esm = __webpack_require__(12338);
// EXTERNAL MODULE: ./node_modules/simple-react-validator/dist/simple-react-validator.min.js
var simple_react_validator_min = __webpack_require__(41283);
var simple_react_validator_min_default = /*#__PURE__*/__webpack_require__.n(simple_react_validator_min);
// EXTERNAL MODULE: ./src/functions/getProductServicesArray.js
var getProductServicesArray = __webpack_require__(84933);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var dist_index_es = __webpack_require__(24762);
// EXTERNAL MODULE: ./src/components/product/AddToCartSelector.jsx + 1 modules
var AddToCartSelector = __webpack_require__(28991);
// EXTERNAL MODULE: ./src/components/product/CampaignBanner.jsx + 3 modules
var CampaignBanner = __webpack_require__(1278);
// EXTERNAL MODULE: ./src/components/product/ProviderDetails.jsx
var ProviderDetails = __webpack_require__(83922);
;// CONCATENATED MODULE: ./src/components/productcollection/common/product.jsx











var formatCurrency = __webpack_require__(9180);







var Product = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Product, Component);
    var _super = (0,_create_super/* default */.Z)(Product);
    function Product(props) {
        (0,_class_call_check/* default */.Z)(this, Product);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "minusQty", function() {
            if (_this.state.quantity > 1) {
                _this.setState({
                    stock: "In Stock"
                });
                _this.setState({
                    quantity: _this.state.quantity - 1
                });
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "plusQty", function() {
            if (_this.props.product.stock >= _this.state.quantity) {
                _this.setState({
                    quantity: _this.state.quantity + 1
                });
            } else {
                _this.setState({
                    stock: "Out of Stock"
                });
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "changeQty", function(e) {
            _this.setState({
                quantity: parseInt(e.target.value)
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "renderServices", function(serviceArray) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "test"
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "showProviderDetails", function() {
            _this.setState({
                providerLoading: true
            });
            var _providerId = _this.props.product.selectedProviderService.providerId, Latitude = _providerId.Latitude, Longitude = _providerId.Longitude;
            var ProviderId = _this.props.product.selectedProviderService.providerId.ProviderId;
            if (ProviderId && Latitude) {
                var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
                var url = "https://api.marketring-api.com/v1/providerlocations/".concat(ProviderId, "?GoogleData=true&lat=").concat(Latitude, "&lng=").concat(Longitude);
                var result = axios/* default.get */.Z.get(url, {
                    crossdomain: true
                }).then(function(response) {
                    _this1.setState({
                        providerDetails: response.data,
                        providerLoading: false,
                        showProviderDetails: true
                    });
                }).catch(function(error) {
                    return null;
                });
                return result;
            } else {
                return null;
            }
        });
        _this.productBox = /*#__PURE__*/ react.createRef();
        _this.state = {
            providerLoading: false,
            showProviderDetails: false,
            providerLat: null,
            providerLng: null,
            productBoxWidth: 0,
            productBoxHeight: 0,
            open: false,
            stock: "In Stock",
            quantity: 1,
            activeIndex: 0,
            image: "",
            selectedServiceIndex: 0,
            forceRender: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(Product, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    productBoxWidth: this.productBox.current.offsetWidth,
                    productBoxHeight: this.productBox.current.offsetHeight
                });
            }
        },
        {
            key: "onClickHandle",
            value: function onClickHandle(img) {
                this.setState({
                    image: img
                });
            }
        },
        {
            key: "BuyNow",
            value: function BuyNow(item, quantity) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.props.onAddToCartClicked(item, quantity)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref, ref1, ref2;
                var _props = this.props, product = _props.product, symbol = _props.symbol, applicationSlug = _props.applicationSlug, onAddToCartClicked = _props.onAddToCartClicked, onAddToWishlistClicked = _props.onAddToWishlistClicked, onAddToCompareClicked = _props.onAddToCompareClicked, isRelated = _props.isRelated, provider = _props.provider, index = _props.index, cartlist = _props.cartlist, externalrequest = _props.externalrequest, reviews = _props.reviews;
                var orderIndex = index + 1;
                var specificIndex = orderIndex % 4 === 0;
                var ref3 = (0,getProductServicesArray/* getProductServicesArray */.U)(product, this.state.selectedServiceIndex, provider, externalrequest), serviceArray = ref3.serviceArray, selectedServiceIndex = ref3.selectedServiceIndex, optionalServiceArray = ref3.optionalServiceArray;
                var IsAvailable = true;
                if (serviceArray.length == 0) {
                    IsAvailable = false;
                }
                var related = "col-xl-3 col-md-6 col-grid-box";
                if (isRelated ? isRelated : false) {
                    related = "col-grid-box";
                }
                var productUrl = "/product/".concat(product.urlSlug);
                var hrefUrl = "/product/[productid]";
                if (applicationSlug != undefined) {
                    productUrl = "".concat(productUrl, "/").concat(applicationSlug);
                    hrefUrl = "".concat(hrefUrl, "/[crossreferenceid]");
                }
                product.returnURL = productUrl;
                var open = this.state.open;
                var imageUrl = product ? product.productPictures.length > 0 ? product.productPictures[0].imageUrl : __webpack_require__(52675) : "";
                var providerMsrp = (product === null || product === void 0 ? void 0 : (ref = product.selectedProviderService) === null || ref === void 0 ? void 0 : ref.providerId) ? Math.round(product.selectedProviderService.providerId.Price * 1.15, 2) : undefined;
                var msrp = Math.round(product.price * 1.15, 2);
                return typeof product != "undefined" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_es/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onMouseLeave: function() {
                                return _this.setState({
                                    showProviderDetails: false
                                });
                            },
                            className: "product-box-container group",
                            children: [
                                this.state.showProviderDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderDetails/* default */.Z, {
                                    reviews: reviews,
                                    specificIndex: specificIndex,
                                    optionalServiceArray: optionalServiceArray,
                                    lat: product.selectedProviderService.providerId.Latitude,
                                    lng: product.selectedProviderService.providerId.Longitude,
                                    show: this.state.showProviderDetails,
                                    data: this.state.providerDetails,
                                    width: this.state.productBoxWidth,
                                    height: this.state.productBoxHeight,
                                    left: this.state.productBoxWidth + 30,
                                    close: function() {
                                        return _this.setState({
                                            showProviderDetails: false
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-box ".concat(product.isFeatured || product.isRecommended ? "promoted" : ""),
                                    ref: this.productBox,
                                    children: [
                                        product.isRecommended ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "featured-text recommended",
                                            children: "Recommended"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "featured-text",
                                            children: "Featured"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBanner/* default */.Z, {
                                            campaigns: product.campaigns
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: hrefUrl,
                                            as: productUrl,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "has-overlay",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "overlay",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "inner",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fad fa-link fa-2x"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                        children: "Click Here for More Details"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "img-wrapper",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "front",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    layout: "fill",
                                                                    objectFit: "contain",
                                                                    src: imageUrl,
                                                                    alt: ""
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-details",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "text-content",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                            children: product.name
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: product.shortDescription
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "price-content",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                            className: "free-installation",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: product.priceTerm ? product.priceTerm : product.groupMessage ? "Online Only Price" : ""
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "money",
                                                                                children: [
                                                                                    symbol,
                                                                                    formatCurrency(providerMsrp || msrp)
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                                            children: [
                                                                                symbol,
                                                                                formatCurrency((product === null || product === void 0 ? void 0 : (ref1 = product.selectedProviderService) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.providerId) === null || ref2 === void 0 ? void 0 : ref2.Price) || product.price)
                                                                            ]
                                                                        }),
                                                                        product.groupMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "indicator ",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "graphic",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            style: {
                                                                                                left: product.groupMessage === "Ultimate" ? "85%" : product.groupMessage === "Best" ? "70%" : product.groupMessage === "Better" ? "50%" : product.groupMessage === "Good" ? "30%" : product.groupMessage === "Lowest" ? "10%" : "85%"
                                                                                            },
                                                                                            className: "fad fa-triangle"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "square",
                                                                                            style: {
                                                                                                left: product.groupMessage === "Ultimate" ? "90%" : product.groupMessage === "Best" ? "80%" : product.groupMessage === "Better" ? "70%" : product.groupMessage === "Good" ? "60%" : product.groupMessage === "Lowest" ? "50%" : "85%"
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: product.groupMessage ? product.groupMessage : ""
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "disclaimer",
                                                            children: [
                                                                "Order Today - Get Today",
                                                                " ",
                                                                product.warranty && "with ".concat(product.warranty, " warranty"),
                                                                ".",
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "available-services",
                                            children: serviceArray.length > 0 && !this.props.isUpdating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartSelector/* default */.Z, {
                                                reviews: reviews,
                                                cartlist: cartlist,
                                                compact: true,
                                                optionalServiceArray: optionalServiceArray,
                                                serviceArray: serviceArray,
                                                selectedServiceIndex: selectedServiceIndex,
                                                item: product,
                                                addToWishlistClicked: onAddToWishlistClicked,
                                                addToCartClicked: onAddToCartClicked,
                                                setSelectedProvider: this.props.setSelectedProvider,
                                                showProviderDetails: this.showProviderDetails,
                                                providerLoading: this.state.providerLoading,
                                                provider: provider,
                                                symbol: this.props.symbol,
                                                forceState: this.props.forceState,
                                                externalrequest: this.props.externalrequest
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "not-available-text",
                                                children: this.props.isUpdating ? "Updating Locations - Please Wait" : "Not Available for your location"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-xl-3 col-md-6 col-grid-box",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                });
            }
        }
    ]);
    return Product;
}(react.Component);
/* harmony default export */ var product = (Product);

;// CONCATENATED MODULE: ./src/components/productcollection/common/product-listing.jsx












// import custom components














var customStyles = {
    singleValue: function(provided, state) {
        var opacity = state.isDisabled ? 0.5 : 1;
        var transition = "opacity 300ms";
        return {
            provided: provided,
            opacity: opacity,
            transition: transition
        };
    },
    control: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            // padding: '0.5rem',
            border: "2px solid #eff8fc"
        });
    },
    menu: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            position: "static"
        });
    },
    input: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            height: "0px"
        });
    },
    // FIXME: Duplicate value (V.T. 21.12.2021.)
    // singleValue: provided => ({
    // 	...provided,
    // 	color: '#0b7a9a',
    // }),
    placeholder: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            color: "#0b7a9a"
        });
    },
    menuList: function(provided) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            maxHeight: "1000px !important"
        });
    }
};
var product_listing_formatCurrency = __webpack_require__(9180);
var ProductListing = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ProductListing, Component);
    var _super = (0,_create_super/* default */.Z)(ProductListing);
    function ProductListing(props) {
        (0,_class_call_check/* default */.Z)(this, ProductListing);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onOpenModal", function() {
            _this.setState({
                preferenceModalOpen: true
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onCloseModal", function() {
            _this.setState({
                preferenceModalOpen: false
            });
        });
        // FIXME: Hack for forcing state to re-render when provider changed.
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "forceState", function() {
            _this.setState({
                forceState: !_this.state.forceState
            });
        });
        _this.state = {
            limit: 25,
            hasMoreItems: true,
            productListingGroupsMeta: [],
            productListingGroups: [],
            forceState: false,
            preferenceModalOpen: true,
            needHelp: true,
            retrievingType: null,
            productLevelType: null,
            size: 0
        };
        _this.validator = new (simple_react_validator_min_default())({
            locale: "en",
            autoForceUpdate: (0,_assert_this_initialized/* default */.Z)(_this)
        });
        _this.submitFilter = _this.submitFilter.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ProductListing, [
        {
            key: "fetchMoreItems",
            value: function fetchMoreItems() {
            // console.log("Do Nothing Yet..");
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var hasLabor;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                hasLabor = _this.props.productServices.find(function(element) {
                                    return element.hasLabor == true;
                                }) ? true : false;
                                _this.setState({
                                    needHelp: hasLabor
                                });
                                return [
                                    4,
                                    _this.updateProductList()
                                ];
                            case 1:
                                _state.sent();
                                if (true) {
                                    _this.setState({
                                        size: window.innerWidth
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "submitFilter",
            value: function submitFilter() {
                var _this = this;
                if (this.validator.allValid()) {
                    var phoneNumber = this.props.masterProvider.isActive ? this.props.masterProvider.phoneNumber : "1-800-228-8379";
                    var googleNumber = (0,findPhoneNumbersInText/* findPhoneNumbersInText */.t)(phoneNumber, "US");
                    if (googleNumber.length > 0) {
                        googleNumber = (0,parsePhoneNumber/* parsePhoneNumber */.S)(googleNumber[0].number.number);
                        phoneNumber = googleNumber.formatNational();
                        googleNumber = googleNumber.getURI();
                    }
                    if (this.state.retrievingType == "call") {
                        // FIXME: use a tag "phone: " attribute (V.T. 11.2.2022)
                        if (true) {
                            window.open({
                                phoneNumber: phoneNumber
                            });
                        }
                        return;
                    }
                    if (this.state.retrievingType == null) {
                        dist/* default.info */.ZP.info("Please Select How you would like to receive item..");
                        return;
                    }
                    var selectedServices = this.props.productServices.find(function(element) {
                        return element.ButtonGrouping == _this.state.retrievingType;
                    });
                    this.props.sortProductCollection(this.props.productList, selectedServices, this.state.productLevelType);
                    this.setState({
                        preferenceModalOpen: false
                    });
                } else {
                    this.validator.showMessages();
                    this.forceUpdate();
                    return false;
                }
            }
        },
        {
            key: "updateProductList",
            value: function updateProductList() {
                var availableSortSequences = uniqBy_default()(this.props.productList, "serviceSortSequence");
                var grouped = functions_groupArrayByValue(this.props.productList, function(type) {
                    return type.serviceSortSequence;
                });
                var groups = [];
                var products = [];
                availableSortSequences.map(function(item, index) {
                    groups.push({
                        id: item.serviceSortSequence,
                        title: item.serviceGroupMessage
                    });
                    products.push(grouped.get(item.serviceSortSequence));
                });
                this.setState({
                    productListingGroupsMeta: groups,
                    productListingGroups: products
                });
                var trackProducts = [];
                this.props.productList.map(function(prod, index) {
                    trackProducts.push({
                        product_id: prod.bigCommerceId,
                        sku: prod.sku,
                        name: prod.name,
                        price: prod.price,
                        position: index,
                        category: prod.categoryId,
                        brand: prod.brandId
                    });
                });
                analytics.track("Product List Viewed", {
                    category: this.props.applicationLabel,
                    products: trackProducts
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(prevProps.productList !== _this.props.productList)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.updateProductList()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var multibutton = this.state.size >= 768 ? true : false;
                var validator = this.validator;
                var _props = this.props, productList = _props.productList, _$addToCart = _props.addToCart, _$addToWishlist = _props.addToWishlist, _$addToCompare = _props.addToCompare, applicationSlug = _props.applicationSlug, applicationLabel = _props.applicationLabel, provider = _props.provider, productServices = _props.productServices, category = _props.category, reviews = _props.reviews;
                var _state = this.state, productListingGroupsMeta = _state.productListingGroupsMeta, productListingGroups = _state.productListingGroups, needHelp = _state.needHelp, retrievingType = _state.retrievingType;
                var hasLabor = productServices.find(function(element) {
                    return element.hasLabor == true;
                }) ? true : false;
                if (category && category && category.id == 2) {
                // FIXME: this is not used anywhere => isAutomotive = true;
                }
                var productLevel = productList.filter(function(product) {
                    return product.productServiceButtons.some(function(service) {
                        return service.ButtonGrouping == retrievingType;
                    }) && product.groupMessage != null && product.groupMessage != "";
                });
                var levels = productLevel.map(function(item) {
                    return item.groupMessage;
                }).filter(function(value, index, self) {
                    return self.indexOf(value) === index;
                });
                var serviceLevels = [];
                var levelsOptions = [];
                levels.forEach(function(level) {
                    var prod = productList.filter(function(product) {
                        return product.productServiceButtons.some(function(service) {
                            return service.ButtonGrouping == retrievingType;
                        }) && product.groupMessage == level && product.groupMessage != "";
                    })[0];
                    serviceLevels.push({
                        level: level,
                        price: prod.price,
                        warranty: prod.warranty,
                        callForPrice: prod.callForPrice
                    });
                });
                for(var i = 0; i < levels.length; i++){
                    levelsOptions.push({
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "complex-selection",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "indicator",
                                    style: {
                                        color: levels[i] === "Ultimate" ? "#26A134" : levels[i] === "Best" ? "#BCCF2B" : levels[i] === "Better" ? "#EADE22" : levels[i] === "Good" ? "#DDAE32" : levels[i] === "Lowest" ? "#BA7338" : "#BA7338"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-circle"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "main",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: levels[i]
                                                }),
                                                " Price and Performance"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "description",
                                            children: serviceLevels[i].callForPrice ? "Please Call for Price" : "Starting at: $".concat(product_listing_formatCurrency(serviceLevels[i].price))
                                        }),
                                        serviceLevels[i].warranty && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "description",
                                            children: "Warranty: ".concat(serviceLevels[i].warranty)
                                        })
                                    ]
                                })
                            ]
                        }),
                        value: levels[i]
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        productListingGroupsMeta.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "category-section-selection",
                            children: [
                                multibutton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "Service:"
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "btn",
                                        href: "#help",
                                        onClick: function() {
                                            return _this.setState({
                                                preferenceModalOpen: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fad fa-question-circle",
                                                "aria-hidden": "true"
                                            }),
                                            " ",
                                            multibutton ? "Help Me Decide" : "Click Here for Item Selection Help"
                                        ]
                                    }, "help")
                                }),
                                multibutton ? productListingGroupsMeta.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "btn",
                                        href: "#".concat(item.title),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-bars",
                                                "aria-hidden": "true"
                                            }),
                                            " ",
                                            item.title
                                        ]
                                    }, item.title);
                                }) : ""
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-wrapper-grid",
                            children: [
                                productServices.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_modal_esm/* default */.Z, {
                                    classNames: {
                                        modal: "change-location-modal preference-question-modal"
                                    },
                                    open: this.state.preferenceModalOpen,
                                    onClose: this.onCloseModal,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "location-items-integrated preference-question-modal-inner",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "header",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "info mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "far fa-info-circle"
                                                                }),
                                                                " Personalize the Selection"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "button-container",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                className: "btn",
                                                                onClick: function() {
                                                                    return _this.setState({
                                                                        preferenceModalOpen: false
                                                                    });
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-times",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    "Cancel"
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "body",
                                                children: [
                                                    hasLabor && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        id: "installhelp",
                                                        className: "item p-0 mb-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Do you need help installing?"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "btn-group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                        id: "help",
                                                                        className: "btn ".concat(needHelp ? "selected" : ""),
                                                                        onClick: function() {
                                                                            return _this.setState({
                                                                                needHelp: true,
                                                                                retrievingType: null,
                                                                                productLevelType: null
                                                                            });
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "icon",
                                                                                children: needHelp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-check-circle"
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "far fa-circle"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "text",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "main-text",
                                                                                        children: "Yes, I'll need help"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "help-text",
                                                                                        children: "Recommended - Using our Certified Installers."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "help-text",
                                                                                        children: "".concat(category && category.id == 2 ? "on your ".concat(category.applicationLabel) : "")
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "help-text",
                                                                                        children: category && category.id == 2 ? "Your vehicle may require a computer reset." : ""
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                        id: "dify",
                                                                        className: "btn ".concat(needHelp === false ? "selected" : ""),
                                                                        onClick: function() {
                                                                            return _this.setState({
                                                                                needHelp: false,
                                                                                retrievingType: null,
                                                                                productLevelType: null
                                                                            });
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "icon",
                                                                                children: needHelp === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-check-circle"
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "far fa-circle"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "text",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "main-text",
                                                                                    children: "No, I'll do it on my own"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        id: "serviceselect",
                                                        className: "item p-0 mb-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Please select how to get the item?"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "btn-group",
                                                                children: [
                                                                    productServices.filter(function(element) {
                                                                        return element.hasLabor == needHelp;
                                                                    }).map(function(item, index) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            className: "btn ".concat(retrievingType === item.ButtonGrouping ? "selected" : ""),
                                                                            onClick: function() {
                                                                                return _this.setState({
                                                                                    retrievingType: item.ButtonGrouping
                                                                                });
                                                                            },
                                                                            children: [
                                                                                retrievingType === item.ButtonGrouping ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "icon",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        className: "fas fa-check-circle"
                                                                                    })
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "icon",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        className: "far fa-circle"
                                                                                    })
                                                                                }),
                                                                                item.ButtonGrouping
                                                                            ]
                                                                        }, index);
                                                                    }),
                                                                    productServices.filter(function(element) {
                                                                        return element.hasLabor == needHelp;
                                                                    }).length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        id: "unavailable",
                                                                        className: "btn",
                                                                        children: "Service is unavailable in your area."
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "mt-2",
                                                                        children: validator.message("selection", this.state.retrievingType, "required")
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    retrievingType && levels.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        id: "productlevelselect",
                                                        className: "item p-0 mb-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Select your Value Level?"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                                                options: levelsOptions.reverse(),
                                                                styles: customStyles,
                                                                onChange: function(value) {
                                                                    _this.setState({
                                                                        productLevelType: value.value
                                                                    });
                                                                },
                                                                isSearchable: false
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "mt-3",
                                                                children: validator.message("Value Level", this.state.productLevelType, "required")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "footer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-center",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                id: "submit",
                                                                className: "block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 bg-[#0ebcee] text-white shadow-sm hover:bg-[#0889ad] w-100 border-none",
                                                                type: "button",
                                                                onClick: function() {
                                                                    return _this.submitFilter();
                                                                },
                                                                children: "Submit"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }) : "",
                                productList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es, {
                                        dataLength: this.state.limit,
                                        next: this.fetchMoreItems,
                                        hasMore: this.state.hasMoreItems,
                                        endMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "seen-cls seen-it-cls",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "List Completed"
                                            })
                                        }),
                                        children: productListingGroupsMeta.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "category-section",
                                                id: item.title,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "section-header",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                            children: [
                                                                item.title,
                                                                item.id >= 100 && item.id <= 199 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "subtitle",
                                                                        children: "We come to your location and do the delivery, testing, and installation."
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mx-auto",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-1 lg:grid-cols-3 lg:gap-x-8",
                                                            children: productListingGroups[index].map(function(item, i) {
                                                                item.applicationLabel = category.applicationLabel.trim();
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(product, {
                                                                    reviews: reviews,
                                                                    cartlist: _this.props.cartlist,
                                                                    index: i,
                                                                    product: item,
                                                                    symbol: "$",
                                                                    onAddToWishlistClicked: function() {
                                                                        return _$addToWishlist(item);
                                                                    },
                                                                    onAddToCompareClicked: function() {
                                                                        return _$addToCompare(item);
                                                                    },
                                                                    onAddToCartClicked: function() {
                                                                        return _$addToCart(item, 1);
                                                                    },
                                                                    applicationSlug: applicationSlug,
                                                                    applicationLabel: applicationLabel,
                                                                    provider: provider,
                                                                    externalrequest: _this.props.externalrequest,
                                                                    setSelectedProvider: _this.props.setSelectedProvider,
                                                                    showBuyButton: _this.props.showBuyButton,
                                                                    isUpdating: _this.props.isUpdating,
                                                                    forceState: _this.forceState
                                                                }, i);
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-sm-12 text-center section-b-space mt-5 no-found",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "../../static/images/empty-search.jpg",
                                                className: "img-fluid mb-4 lazyload",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Loading... "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Please call us if you have any questions."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                as: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "btn success",
                                                    children: "Continue Shopping"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ProductListing;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        provider: state.provider,
        category: state.category,
        cartlist: state.cartlist
    };
};
/* harmony default export */ var product_listing = ((0,es/* connect */.$j)(mapStateToProps, {
    addToCart: actions/* addToCart */.Xq,
    addToWishlist: actions/* addToWishlist */.Mp,
    addToCompare: actions/* addToCompare */.a$,
    sortProductCollection: actions/* sortProductCollection */.PZ
})(ProductListing));

// EXTERNAL MODULE: ./src/components/category/LocationRequiredOverlay/index.jsx
var LocationRequiredOverlay = __webpack_require__(76216);
;// CONCATENATED MODULE: ./src/components/productcollection/index.js










var Collection = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Collection, Component);
    var _super = (0,_create_super/* default */.Z)(Collection);
    function Collection(props) {
        (0,_class_call_check/* default */.Z)(this, Collection);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showAddressModal: props.locationRequired ? props.locationRequired : false,
            forceUpdate: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(Collection, [
        {
            key: "onOpenModal",
            value: function onOpenModal() {
                this.setState({
                    showAddressModal: true
                });
            }
        },
        {
            key: "onCloseModal",
            value: function onCloseModal() {
                this.setState({
                    showAddressModal: false
                });
            }
        },
        {
            key: "getBio",
            value: function getBio(products) {
                var bio = null;
                for(var i = 0; i < products.length; ++i){
                    bio = products[i].selectedProviderService ? products[i].selectedProviderService.providerId : null;
                    if (bio) {
                        break;
                    }
                }
                return bio && bio.ShowBio && /*#__PURE__*/ (0,jsx_runtime.jsx)(Bio/* default */.Z, {
                    showFitmentDisclaimer: true,
                    imageUrl: bio.DriverImageUrl,
                    name: bio.Name,
                    quote: bio.DriverBio
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                if (this.props.geolocation) {
                    if (this.props.geolocation.isGeoLocationAvailable && !this.props.geolocation.isGeoLocationEnabled) {
                        this.setState({
                            showAddressModal: true
                        });
                    }
                }
                // FIXME: Hack for forcing re-render.
                setTimeout(function() {
                    _this.setState({
                        forceUpdate: !_this.state.forceUpdate
                    });
                }, 0);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, products = _props.products, label = _props.label, applicationSlug = _props.applicationSlug, provider = _props.provider, geolocation = _props.geolocation, locationRequired = _props.locationRequired, imageUrl = _props.imageUrl, isUpdating = _props.isUpdating, isFeatured = _props.isFeatured, externalrequest = _props.externalrequest, reviews = _props.reviews;
                var first_name = null;
                if (externalrequest) {
                    first_name = this.props.externalrequest.request ? this.props.externalrequest.request.address.firstName : this.customer ? this.customer.first_name : null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "collection-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "collection-content col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "page-main-content",
                                    children: [
                                        !isFeatured ? /*#__PURE__*/ (0,jsx_runtime.jsx)(collection_title["default"], {
                                            isAvailable: this.props.productServices.length >= 1,
                                            locationRequired: locationRequired,
                                            label: label,
                                            geolocation: geolocation,
                                            imageUrl: imageUrl,
                                            isUpdating: isUpdating,
                                            first_name: first_name
                                        }) : "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "collection-product-wrapper",
                                            children: [
                                                locationRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationRequiredOverlay/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(product_listing, {
                                                    productList: products,
                                                    applicationSlug: applicationSlug,
                                                    applicationLabel: label,
                                                    provider: provider,
                                                    setSelectedProvider: this.props.setSelectedProvider,
                                                    showBuyButton: this.props.showBuyButton,
                                                    isUpdating: this.props.isUpdating,
                                                    productServices: this.props.productServices,
                                                    masterProvider: this.props.masterProvider,
                                                    externalrequest: this.props.externalrequest,
                                                    reviews: reviews
                                                })
                                            ]
                                        }),
                                        products && this.getBio(products)
                                    ]
                                })
                            })
                        })
                    })
                });
            }
        }
    ]);
    return Collection;
}(react.Component);
/* harmony default export */ var productcollection = (Collection);


/***/ })

}]);